import getTestProps from './getTestProps';
import DataTestAttrs from './shared/DataTestAttrs';

/**
 * Add data test attributes to a direct DOM element (as opposed to a jQuery wrapper).
 */
export default function addTestAttrsToDOMElement(el: Element, dataTestAttrs: DataTestAttrs): void {
  for (const [key, val] of Object.entries(getTestProps(dataTestAttrs))) {
    el.setAttribute(key, val);
  }
}
